<template>
  <fragment  v-if="$store.getters.isInRole('stats-note')">
  <div class="row">
      <div class="col-12">
        <div class="card m-b-30">
          <div class="card-body">
    <div class="row">
      
      <div class="col-8">
        
        
        <FullCalendar :options="calendarOptions" ref="calendar" />
    </div>
    <div class="col-4">
      <div class="row" >
        <div class="col-12" v-if="isLoading">
          Caricamento nota in corso...
        </div>
  <div class="col-12" v-if="!isLoading">
                <b-form-datepicker
                  :show-decade-nav="true"
                  placeholder="Nessuna data selezionata"
                  v-model="entity.date"
                  :id="'to-datepicker'"
                  :reset-button="true"
                  label-reset-button="Nessuna data"
                  reset-button-variant="btn-xs btn-danger-rgba"
                ></b-form-datepicker>
              </div>
              <div class="col-12 mt-2"  v-if="!isLoading">
   <v-select :options="cities"  multiple  v-model="entity.cityList" placeholder="Comuni"   />
              </div>
              <div class="col-12 mt-2"  v-if="!isLoading">
   <v-select :options="newspapers" multiple  v-model="entity.newspaperList" placeholder="Testate"   />
              </div>
            </div>
            <div class="col-12 mt-2"  v-if="!isLoading">
              <div class="form-group">
                                    <textarea class="form-control"  v-model="entity.content"  rows="3" placeholder="Nota"></textarea>
                                </div>


            </div>
 <div class="col-12 mt-2"  v-if="!isLoading">
   <button class="btn btn-primary-rgba mr-2" @click="saveNote">Salva</button>
   <button class="btn btn-danger-rgba mr-2" @click="removeNote" v-if="!entity.isNew">Elimina Nota</button>

 </div>
      </div>

    </div>
    </div>
 
          </div>
        </div>
      
      </div>
    <a ref="attachmentA"></a>
 
  
  </fragment>
</template>
<style scoped>
.attachment-filename {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
let vm_scope;
import axios from "axios";
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

import itLocale from '@fullcalendar/core/locales/it';
import Breadcrumb from '../../components/Breadcrumb.vue';
export default {
  name: "kiosk",

  props: {
 
  },
  components: {
FullCalendar,
    Breadcrumb

  },
  data() {
    return {
    isLoading: false,
      entity:{
kioskNoteId:'',
 cityList:[],
 newspaperList:[],
  content:"",
  date:null

      },
      cities:[],
      newspapers :[],
      calendarEvents:[],
     
       calendarOptions: { 
       themeSystem: 'bootstrap',
         eventClick: this.handleEventClick,
         events: this.events,
         locale:"it",
        plugins: [ dayGridPlugin, interactionPlugin ],
        initialView: 'dayGridWeek',
      headerToolbar:  {
  start: 'prev,next,,today', // will normally be on the left. if RTL, will be on the right
  center: 'title',
  end: '' // will normally be on the right. if RTL, will be on the left
}
      }
    };
  },
  mounted() {
    var me = this;
  axios
        .get(`kiosk/cities`)
        .then((response) => {
          this.cities = response.data;
        });

         axios
        .get(`kiosk/newspapers`)
        .then((response) => {
          this.newspapers = response.data;
        });

        this.loadNote();
  },
  methods: {

removeNote:function(){
  var me = this;
me.$swal({
        title: ``,
        html: `Sicuri di eliminare la nota?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .delete('kiosk/note/'+me.entity.kioskNoteId)
            .then((response) => {
              me.$swal({
                title: "Cancellazione nota avvenuta con successo",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });

            me.refreshEvents();
            me.loadNote();
            });
        }
      });


},

    handleEventClick:function(info){
this.loadNote(info.event.id);

    },
    refreshEvents(){
      let calendarApi = this.$refs.calendar.getApi();
      calendarApi.refetchEvents()

    }
    ,
    loadNote(id){
      this.isLoading =true;
axios.get('kiosk/note/'+(id||'')).then((response)=>{
this.entity = response.data;
this.entity.isNew = !id;
 this.isLoading =false;
});

    },
saveNote(){
this.entity.cities = this.entity.cityList.join(';');
this.entity.newspapers = this.entity.newspaperList.join(';');
axios.post('kiosk/note',this.entity).then((response) =>{


 this.$swal({
                title: "Salvataggio nota avvenuta con successo",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });

              this.loadNote();
this.refreshEvents();
})
},
    events:function(info, successCallback, failureCallback){
      axios.get(`kiosk/notes?start=${info.startStr.substring(0, 10)}&end=${info.endStr.substring(0, 10)}`).then((response)=>{
successCallback(response.data);

      });

    },
    getExtensionIcon: function (ext) {
      if (ext) ext = ext.toLowerCase();
      else ext = "";
      switch (ext) {
        case ".txt":
          return "fa fa-file-text-o";
        case ".doc":
        case ".docx":
          return "fa fa-file-word-o  text-info";
        case ".xls":
        case ".xlsx":
        case ".csv":
          return "fa fa-file-excel-o text-success";
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".bmp":
        case ".tiff":
          return "fa fa-image-o  text-info";
        case ".pdf":
          return "fa fa-file-pdf-o text-danger";
        case ".wav":
        case ".mp3":
          return "fa fa-file-audio-o text-warning";
        case ".ppt":
        case ".pptx":
          return "fa fa-file-powerpoint-o text-warning";
        case ".zip":
        case ".rar":
        case ".7z":
          return "fa fa-file-archive-o  text-warning";
        default:
          return "fa fa-file-o";
      }
    },
    dropzoneOptions: function () {
      var me = this;
      vm_scope = this;
      function url() {
        return (
          window.SETTINGS.apiUrl +
          "/kiosk/" +
          me.agency 
        );
      }
      return {
        url: url,
        headers: { Authorization: "Bearer " + this.$store.state.user.token },
        success: function (a, b) {
          this.removeFile(a);
         
        },
      };
    },

  },
};
</script>
